var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('am-phone',_vm._g(_vm._b({attrs:{"errorText":_vm.errorKey ? _vm.messages[_vm.errorKey] : _vm.errorText,"value":_vm.value},on:{"model":function($event){return _vm.$emit('model', _vm.value)},"blur":function($event){return _vm.validator.$touch()}}},'am-phone',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }